import * as React from "react";
import { useState } from "react";
import MobileApplicationView from "./MobileApplicationView";
import ModalPopup from "../commons/components/modal/ModalPopup";
import "./MobileApplicationLink.scss";

export default function MobileApplicationLink({
  mobileApplicationView,
}: {
  mobileApplicationView: MobileApplicationView;
}) {
  const [showMobileApplicationDownloadPopup, setShowMobileApplicationDownloadPopup] =
    useState<Boolean>();

  return (
    <>
      <button
        className={"button-primary"}
        onClick={() => setShowMobileApplicationDownloadPopup(true)}
      >
        <i className={"ic_download"} />
        <span>{i18n["Page.Portal.DownloadApplication.Title"]}</span>
      </button>
      {showMobileApplicationDownloadPopup && (
        <ModalPopup
          id={"mobile-app-modal"}
          class={"v-flex"}
          closeModal={() => setShowMobileApplicationDownloadPopup(false)}
        >
          <div className={"mobile-app-modal-content v-flex"}>
            <div className="title">{i18n["Page.Portal.DownloadApplication.Title"]}</div>
            <div className={"content-description"}>
              {i18n["Page.Portal.DownloadApplication.Button.Modal.Content"]}
            </div>
            <div className={"badges h-flex"}>
              <a href={mobileApplicationView.appleStore.storeUrl} target={"_blank"}>
                <img
                  className={"store-badge"}
                  src={mobileApplicationView.appleStore.badgeUrl}
                  alt={"Apple store mobile app url"}
                />
              </a>
              <a href={mobileApplicationView.playStore.storeUrl} target={"_blank"}>
                <img
                  className={"store-badge"}
                  src={mobileApplicationView.playStore.badgeUrl}
                  alt={"Play store mobile app url"}
                />
              </a>
            </div>
          </div>
        </ModalPopup>
      )}
    </>
  );
}
